/*
  Quick and dirty way to make URLs relative
 */
const getRelativeUrl = (url) => {
  return url
    .replace('http://localhost:8080', '')
    .replace('http://www.flowfestival.com', '')
    .replace('https://www.flowfestival.com', '');
};

const getLinkTarget = (target) => {
  return target ? target : '';
};

const getHashLink = (url) => {
  return url.toLowerCase().split(' ').join('-');
};

const getLangMappedUrl = (url, lang, settings) => {
  const {
    languages
  } = settings;

  if (lang === languages['default']) {
    return url;
  } else {
    return `/${lang}${url}`;
  }
};

const pageValidForInclusion = (slug) => {
  return [
    'artists',
    'vr',
    'art',
    'frontpage',
    'frontpage-2',
    '14919-2',
    'food',
    'ruoka',
    'news',
    'art',
    'taide',
    'aikataulu',
    'schedule',
    'perhe',
    'talks',
    'family',
    'my-flow',
  ].indexOf(slug) === -1
};

const getSlugBasePath = (slug, slugs) => {
  return slugs[slug];
};

export {
  getRelativeUrl,
  getLinkTarget,
  getHashLink,
  getLangMappedUrl,
  pageValidForInclusion,
  getSlugBasePath
}


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/utils/cleaners.js